import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'CmgProgressBar',
})
export default class CmgProgressBar extends Vue {
    @Prop({ required: true, type: Number })
    public progressPercentage!: number;

    @Prop({ type: Boolean, required: false, default: false })
    animateProgress?: boolean;

    get progressBarWidth(): string {
      return isNaN(Number(this.progressPercentage))
        ? ''
        : `${this.progressPercentage}%`;
    }
}
